// removed by extract-text-webpack-plugin
module.exports = {"SideDrawer":"sideDrawer__SideDrawer__2PbVO","Open":"sideDrawer__Open__fvMgb","Close":"sideDrawer__Close__zq08K","Logo":"sideDrawer__Logo__3LUks"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/SideDrawer/sideDrawer.css
// module id = 146
// module chunks = 8